import { Services } from '@Shared.Angular/@types/services';
import {
  IFlowModelImportOptions,
  IFlowModelParser,
  IImportable,
  IImportableFlowModelFile,
  ImportableFlowModelAttachments
} from '../../../../Flowingly.Angular.Runner/Client/runner.services/flow.model.import.service';

export default class FlowModelAttachmentZipParser implements IFlowModelParser {
  constructor(
    private fflate: Fflate,
    private guidService: Services.GuidService
  ) {}

  parseImportables = (
    importFiles: IImportableFlowModelFile[],
    _options?: IFlowModelImportOptions
  ) => {
    const imports: Promise<IImportable[]>[] = [];
    importFiles.forEach((importFile) => {
      if (!importFile.file.name.toLowerCase().endsWith('.zip')) {
        return;
      }
      try {
        const whenAttachmentsExtracted = this.getProcessAttachments(
          importFile.file
        );
        imports.push(whenAttachmentsExtracted);
        whenAttachmentsExtracted.then(
          (importables) => (importFile.handled = importables.length > 0)
        );
      } catch {
        /* empty */
      }
    });
    return Promise.allSettled(imports).then((results) => {
      return results
        .filter((result) => result.status === 'fulfilled')
        .map((result: PromiseFulfilledResult<IImportable[]>) => result.value)
        .flat();
    });
  };

  private getProcessAttachments = async (file: File) => {
    const buffer = await file.arrayBuffer();
    const fileData = new Uint8Array(buffer);
    const unzippedData = this.fflate.unzipSync(fileData);
    const importables: ImportableFlowModelAttachments[] = [];
    for (const [path, attachmentBytes] of Object.entries(unzippedData)) {
      if (attachmentBytes.length < 1) {
        continue;
      }
      // Files are assumed to be in a folder named with the UniqueProcessId they belong to
      const pathParts = path.split('/').reverse();
      if (pathParts.length < 2) {
        continue;
      }
      const fileName = pathParts[0].trim();
      if (fileName.length < 1) {
        continue;
      }
      const processUniqueId = pathParts[1];
      if (!this.guidService.isValidGuid(processUniqueId)) {
        continue;
      }
      let importable = importables.find((x) => x.key === processUniqueId);
      if (importable === undefined) {
        importable = new ImportableFlowModelAttachments(processUniqueId);
        importables.push(importable);
      }
      importable.attachments.push({
        name: fileName,
        htmlEncodedName: this.escapeHtml(fileName),
        bytes: attachmentBytes
      });
    }
    return importables;
  };

  private escapeHtml(text) {
    const textArea = document.createElement('textarea');
    textArea.innerText = text;
    return textArea.innerHTML;
  }
}
